// Build Your Own Box (templates/collection.build-box.liquid).
// State: size (3|6) and slots[] of picked spices ({id,title,price,img}) or null.
// Picking fills the first empty slot. Jars can be dragged (mouse or finger) between slots, in the
// box photo or the list, to swap; tapping one jar then another also swaps. Add to Cart sends the
// gift box (with an "Arrangement" property listing slot order) plus every jar.
(() => {
  const root = document.querySelector('[data-bb]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-bb-config]').textContent);
  const T = cfg.t;
  const $ = (s) => root.querySelector(s);
  const photo = $('[data-bb-photo]');
  const list = $('[data-bb-list]');
  const grid = $('[data-bb-grid]');
  const cards = [...root.querySelectorAll('[data-bb-card]')];
  const ctas = [$('[data-bb-cta]'), $('[data-bb-mcta]')].filter(Boolean);
  const errEl = $('[data-bb-err]');
  const currency = root.dataset.moneyCurrency || 'USD';
  const fmt = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  const KEY = 'wurzpott-build-box';

  const params = new URLSearchParams(location.search);
  let size = params.get('size') === '6' && cfg.boxes['6'].variant ? 6 : 3;
  if (!cfg.boxes['3'].variant) size = 6;
  // Each box size keeps its own picks, so switching sizes never deletes anything.
  // `slots` is always the array of the box on screen (boxes[size]).
  const boxes = { 3: new Array(3).fill(null), 6: new Array(6).fill(null) };
  // Greeting Card choice per box size: { on, msg } (msg = Custom Message add-on; only with a card).
  const cardSel = { 3: { on: false, msg: false }, 6: { on: false, msg: false } };
  const cardOn = $('[data-bb-card-on]');
  const msgOn = $('[data-bb-msg-on]');
  const cardOk = !!(cardOn && cfg.card && cfg.card.variant);
  const msgOk = !!(msgOn && cfg.card && cfg.card.msgVariant);
  let slots = boxes[size];
  let selected = -1;
  let busy = false;
  // Replace mode: index of the slot whose spice is being changed (-1 = off). The spice menu's Add buttons
  // become Choose + Info until a replacement is chosen or Cancel is tapped.
  let replacing = -1;
  const replaceBar = document.createElement('div');
  replaceBar.className = 'bb-replace-bar';
  replaceBar.hidden = true;
  replaceBar.setAttribute('role', 'status');
  replaceBar.innerHTML = '<span data-bb-replace-text></span><button type="button" data-bb-replace-cancel></button>';
  replaceBar.querySelector('button').textContent = T.cancel;
  grid.before(replaceBar);
  cards.forEach((c) => {
    if (c.hasAttribute('data-soldout')) return;
    const pair = document.createElement('div');
    pair.className = 'bb-card-pair';
    pair.innerHTML = '<button type="button" class="bb-card-choose button-primary" data-bb-choose></button>';
    c.append(pair);
  });
  // Editing a box from the cart (?edit=<_bb id>): { id, keys, label } of the cart lines being replaced.

  // Keep picks if the shopper leaves and comes back (same tab session).
  try {
    // ?new=1 starts with both boxes empty.
    if (params.get('new')) sessionStorage.removeItem(KEY);
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (saved) {
      const ids = new Map(cards.map((c) => [c.dataset.id, c]));
      const restore = (n, list) => new Array(n).fill(null).map((_, i) => {
        const id = list?.[i];
        return id && ids.has(String(id)) ? spiceFromCard(ids.get(String(id))) : null;
      });
      const savedBoxes = saved.boxes || { [saved.size]: saved.ids };
      [3, 6].forEach((n) => { if (savedBoxes[n]) boxes[n] = restore(n, savedBoxes[n]); });
      [3, 6].forEach((n) => { const c = saved.cards?.[n]; if (c) cardSel[n] = { on: !!c.on, msg: !!(c.on && c.msg) }; });
      if (!params.get('size') && cfg.boxes[saved.size]?.variant) size = Number(saved.size);
      slots = boxes[size];
    }
  } catch (e) {}
  // Editing a box from the cart (?edit=<_bb>): { id, keys, label, oldJars: Map(variant → qty) }. Picks in progress stay saved meanwhile.
  let editing = null;
  let prevPicks = null;
  let prevCard = null;
  const save = () => {
    if (editing) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ size, boxes: { 3: boxes[3].map((s) => s && s.id), 6: boxes[6].map((s) => s && s.id) }, cards: cardSel }));
    } catch (e) {}
  };

  function spiceFromCard(card) {
    return { id: card.dataset.id, title: card.dataset.title, price: Number(card.dataset.price) || 0, img: card.dataset.img, jar: card.hasAttribute('data-jar') };
  }
  const filled = () => slots.filter(Boolean).length;
  // Jar picture: jar-only photos are cropped to the jar (.bb-jar); other product photos are shown whole.
  function art(s, alt, cls) {
    const im = document.createElement('img');
    im.src = s.img;
    im.alt = alt;
    im.draggable = false;
    if (!s.jar) { if (cls) im.className = cls; return im; }
    const wrap = document.createElement('span');
    wrap.className = 'bb-jar';
    wrap.append(im);
    return wrap;
  }

  // ---------- Box photo with numbered slots ----------
  function buildPhoto() {
    const box = cfg.boxes[size];
    photo.innerHTML = '';
    // Visible height / width after the top-flap crop, used to keep the photo inside the window on desktop.
    photo.style.setProperty('--bb-ratio', String((box.h / box.w) - box.crop / 100));
    const inner = document.createElement('div');
    inner.className = 'bb-photo-inner';
    inner.style.marginTop = `-${box.crop}%`;
    const img = document.createElement('img');
    img.className = 'bb-box-img';
    img.src = box.img;
    img.alt = box.title;
    img.width = box.w;
    img.height = box.h;
    img.draggable = false;
    inner.append(img);
    box.slots.forEach(([x, y, w, h], i) => {
      const el = document.createElement('div');
      el.className = 'bb-slot';
      el.dataset.slot = i;
      el.dataset.rect = [x, y, w, h].join(',');
      inner.append(el);
    });
    photo.append(inner);
  }

  function render() {
    if (replacing >= slots.length || (replacing >= 0 && !slots[replacing])) replacing = -1;
    const rep = replacing >= 0 ? slots[replacing] : null;
    root.classList.toggle('is-replacing', !!rep);
    replaceBar.hidden = !rep;
    if (rep) replaceBar.querySelector('[data-bb-replace-text]').textContent = T.replaceBar.replace('__N__', replacing + 1).replace('__T__', rep.title);
    cards.forEach((c) => {
      const choose = c.querySelector('[data-bb-choose]');
      if (!choose) return;
      const same = !!rep && c.dataset.id === String(rep.id);
      choose.disabled = same;
      choose.textContent = same ? T.current : T.choose;
    });
    const box = cfg.boxes[size];
    const n = filled();
    const nextEmpty = slots.indexOf(null);
    // Box slots
    photo.querySelectorAll('.bb-slot').forEach((el) => {
      const i = Number(el.dataset.slot);
      const s = slots[i];
      el.innerHTML = '';
      const num = document.createElement('span');
      num.className = 'bb-slot-num';
      num.textContent = i + 1;
      if (s) {
        el.append(art(s, s.title));
        el.dataset.filled = '';
        el.setAttribute('aria-label', `${i + 1}: ${s.title}`);
      } else {
        delete el.dataset.filled;
        el.setAttribute('aria-label', `${i + 1}: ${T.empty}`);
      }
      el.append(num);
      // Every slot in a box gets the same size (average compartment), centered on its own compartment.
      // Empty: white numbered tile at 94% of that. Filled: the jar at 93% of the compartment width (no white).
      const [x, y, w, h] = el.dataset.rect.split(',').map(Number);
      const all = cfg.boxes[size].slots;
      const avgW = all.reduce((a, r) => a + r[2], 0) / all.length;
      const avgH = all.reduce((a, r) => a + r[3], 0) / all.length;
      const scale = s ? 0.93 : 0.94;
      const tw = avgW * scale;
      const th = avgH * scale;
      el.style.left = `${x + w / 2 - tw / 2}%`;
      // Box config jarDy = how far (in % of the JAR's own height) jars sit lower in their compartment (6-pack = 5).
      // Filled: the jar is nudged via --bb-jar-dy. Empty: the white tile moves down the same distance,
      // converted to % of box height (jar height = filled width * 93/70, in box-height units).
      const jarDy = cfg.boxes[size].jarDy || 0;
      const jarH = avgW * 0.93 * (93 / 70) * (cfg.boxes[size].w / cfg.boxes[size].h);
      const tileDy = s ? 0 : (jarH * (cfg.boxes[size].tileDy ?? jarDy)) / 100;
      el.style.top = `${y + h / 2 - th / 2 + tileDy}%`;
      el.style.setProperty('--bb-jar-dy', `${s ? jarDy : 0}%`);
      el.style.width = `${tw}%`;
      el.style.height = `${th}%`;
      el.classList.toggle('is-selected', selected === i);
      el.classList.toggle('is-next', !s && i === nextEmpty);
    });
    // List
    list.innerHTML = '';
    slots.forEach((s, i) => {
      const li = document.createElement('li');
      li.className = 'bb-row';
      li.dataset.slot = i;
      li.classList.toggle('is-selected', selected === i);
      li.classList.toggle('is-replacing', replacing === i);
      const num = document.createElement('span');
      num.className = 'bb-row-num';
      num.textContent = i + 1;
      // Six-dot grip: shows the row can be dragged (the whole row drags; empty rows get a blank spacer).
      const grip = document.createElement('span');
      grip.className = s ? 'bb-grip' : 'bb-grip bb-grip--blank';
      grip.setAttribute('aria-hidden', 'true');
      if (s) grip.innerHTML = '<svg viewBox="0 0 10 16" width="10" height="16" fill="currentColor"><circle cx="2.5" cy="3" r="1.5"/><circle cx="7.5" cy="3" r="1.5"/><circle cx="2.5" cy="8" r="1.5"/><circle cx="7.5" cy="8" r="1.5"/><circle cx="2.5" cy="13" r="1.5"/><circle cx="7.5" cy="13" r="1.5"/></svg>';
      li.append(grip, num);
      if (s) {
        li.dataset.filled = '';
        li.append(art(s, '', 'bb-row-img'));
      }
      const name = document.createElement('span');
      name.className = 'bb-row-name';
      name.textContent = s ? s.title : T.empty;
      li.append(name);
      if (s) {
        // Each spice's live price, so the running total is easy to follow.
        const pr = document.createElement('span');
        pr.className = 'bb-row-price';
        pr.textContent = fmt(s.price);
        li.append(pr);
      }
      if (s) {
        // Change: same green button and spice popup as the cart (snippets/bb-change-dialog.liquid).
        const ch = document.createElement('button');
        ch.type = 'button';
        ch.className = 'bb-row-change';
        ch.dataset.bbChangeSlot = i;
        ch.setAttribute('aria-label', T.changeLabel.replace('__T__', s.title));
        ch.textContent = T.change;
        li.append(ch);
      }
      if (s) {
        const x = document.createElement('button');
        x.type = 'button';
        x.className = 'bb-row-x';
        x.dataset.bbRemove = i;
        x.setAttribute('aria-label', `${T.remove} ${s.title}`);
        x.textContent = '×';
        li.append(x);
      }
      list.append(li);
    });
    // Progress, hint, totals
    const progress = T.progress.replace('__P__', n).replace('__T__', size);
    $('[data-bb-progress]').textContent = progress;
    $('[data-bb-mprogress]').textContent = progress;
    $('[data-bb-bar]').style.width = `${(n / size) * 100}%`;
    const left = size - n;
    // Full box: hide the slot numbers so the preview looks like the real box.
    photo.toggleAttribute('data-full', left === 0);
    $('[data-bb-hint]').textContent = n === 0 ? T.hintEmpty.replace('__N__', size) : left === 0 ? T.hintFull : left === 1 ? T.hintOne : T.hintOther.replace('__N__', left);
    $('[data-bb-tip]').hidden = n < 2 || left === 0;
    // Greeting Card option (also while editing a box from the cart: its card is loaded with it).
    const sel = cardSel[size];
    const cardWrap = $('[data-bb-card-opt]');
    if (cardWrap) cardWrap.hidden = !cardOk;
    const withCard = cardOk && sel.on;
    const withMsg = withCard && msgOk && sel.msg;
    if (cardOn) cardOn.checked = withCard;
    if (msgOn) msgOn.checked = withMsg;
    const msgNote = $('[data-bb-msg-note]');
    if (msgNote) msgNote.hidden = !withMsg;
    const cardCost = (withCard ? cfg.card.price : 0) + (withMsg ? cfg.card.msgPrice : 0);
    // Editing a set that has no gift box: no box price, and no box is added on save.
    const noBox = !!editing?.noBox;
    const total = (noBox ? 0 : box.price) + slots.reduce((a, s) => a + (s ? s.price : 0), 0) + cardCost;
    $('[data-bb-total]').textContent = fmt(total);
    $('[data-bb-mtotal]').textContent = fmt(total);
    let incl = noBox ? "" : `${T.includes.replace("__B__", box.title)} (${fmt(box.price)})`;
    if (withCard) incl += `, ${T.inclCard} (${fmt(cfg.card.price)})`;
    if (withMsg) incl += `, ${T.inclMsg} (${fmt(cfg.card.msgPrice)})`;
    $('[data-bb-includes]').textContent = incl;
    $('[data-bb-clear]').hidden = n === 0 && !sel.on;
    ctas.forEach((b) => {
      if (busy) return;
      b.disabled = left !== 0;
      b.textContent = left === 0 ? (editing ? T.update : T.cta) : T.fill;
    });
    // Cards: count badge, disable when full
    const counts = {};
    slots.forEach((s) => { if (s) counts[s.id] = (counts[s.id] || 0) + 1; });
    cards.forEach((c) => {
      const cnt = counts[c.dataset.id] || 0;
      if (cnt) { c.dataset.count = cnt; c.querySelector('[data-bb-count]').textContent = `×${cnt}`; } else delete c.dataset.count;
      const btn = c.querySelector('[data-bb-add]');
      if (!btn) return;
      btn.disabled = left === 0;
      btn.textContent = left === 0 ? T.full : T.add;
    });
    root.querySelectorAll('[data-bb-size]').forEach((b) => {
      b.setAttribute('aria-pressed', String(Number(b.dataset.bbSize) === size));
    });
    // Editing a set: how switching size treats its spices.
    const sizeHint = $('[data-bb-size-hint]');
    if (sizeHint) {
      const aside = editing && size === 3 ? (editing.big || []).slice(3).filter(Boolean).length : 0;
      const text = !editing ? '' : aside ? T.sizeAside : size === 6 && cfg.boxes[3]?.variant ? T.sizeDown : size === 3 && cfg.boxes[6]?.variant ? T.sizeUp : '';
      if (sizeHint.textContent !== text) sizeHint.textContent = text;
      sizeHint.hidden = !text;
    }
    stick();
    save();
  }

  function setSize(next) {
    replacing = -1;
    if (next === size || !cfg.boxes[next]?.variant) return;
    if (editing) {
      // Editing a set from the cart (merchant, Oct 28 2026): it can switch 3-Pack <-> 6-Pack. Going up keeps its
      // spices in slots 1-3 and opens empty slots; going down keeps slots 1-3 and sets slots 4-6 aside, which come
      // back if the shopper switches up again before updating. The card choice goes with the box.
      const cur = slots;
      if (next > size) {
        boxes[next] = new Array(next).fill(null).map((_, i) => (i < cur.length ? cur[i] : editing.big?.[i] || null));
      } else {
        editing.big = cur.slice();
        boxes[next] = cur.slice(0, next);
      }
      cardSel[next] = { ...cardSel[size] };
      size = next;
      slots = boxes[size];
      selected = -1;
      buildPhoto();
      render();
      return;
    }
    size = next;
    // Each box size keeps only its own picks (and card choice): nothing is copied from one size to the other.
    slots = boxes[size];
    selected = -1;
    buildPhoto();
    render();
  }

  function swap(a, b) {
    if (a === b || a < 0 || b < 0) return;
    [slots[a], slots[b]] = [slots[b], slots[a]];
  }

  // ---------- Events ----------
  root.querySelectorAll('[data-bb-size]').forEach((b) => b.addEventListener('click', () => setSize(Number(b.dataset.bbSize))));

  // Replace mode: Choose puts the spice in the slot being changed; Info shows its details (popup, details only).
  function chooseReplacement(card) {
    if (replacing < 0 || !slots[replacing] || !card) return;
    const i = replacing;
    slots[i] = spiceFromCard(card);
    replacing = -1;
    selected = -1;
    render();
    // Show the shopper where it went: flash the row and bring the box back into view if it's off screen.
    const row = list.querySelector(`.bb-row[data-slot="${i}"]`);
    if (row) {
      const r = row.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      row.animate?.([{ backgroundColor: '#E2A63755' }, { backgroundColor: 'transparent' }], { duration: 900 });
    }
  }
  replaceBar.addEventListener('click', (e) => {
    if (!e.target.closest('[data-bb-replace-cancel]')) return;
    replacing = -1;
    render();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && replacing >= 0 && !document.querySelector('dialog[open]')) { replacing = -1; render(); }
  });
  // No long-press menu (Save image / Copy / Open) on the box photo or jar pictures.
  root.addEventListener('contextmenu', (e) => { if (e.target instanceof Element && e.target.closest('.bb-photo, [data-bb-list]')) e.preventDefault(); });
  // Spice cards (merchant, Oct 28 2026): Add / Select buttons act directly; a click anywhere else on the card
  // (picture, name, price, "More Info") opens the spice's details popup. Its button reads Add (fills the next empty
  // slot) or, while changing a spice, Select (swaps it into that slot).
  function addCard(card) {
    const i = slots.indexOf(null);
    if (i < 0 || !card || card.hasAttribute('data-soldout')) return;
    if (undoState) hideUndo();
    slots[i] = spiceFromCard(card);
    selected = -1;
    render();
    // On phones, a short pulse on the bottom bar confirms the pick without scrolling away.
    const bar = $('[data-bb-mbar]');
    bar?.animate?.([{ transform: 'translateY(0)' }, { transform: 'translateY(-4px)' }, { transform: 'translateY(0)' }], { duration: 250 });
  }
  function openInfo(card) {
    if (!window.bbShowInfo || !card) return;
    if (replacing >= 0 && slots[replacing]) {
      const cur = slots[replacing];
      window.bbShowInfo({ handle: card.dataset.handle, current: cur.id, onPick: () => chooseReplacement(card) });
    } else {
      window.bbShowInfo({ handle: card.dataset.handle, current: '', pickLabel: T.add, disabled: slots.indexOf(null) < 0, onPick: () => addCard(card) });
    }
  }
  grid.addEventListener('click', (e) => {
    const choose = e.target.closest('[data-bb-choose]');
    if (choose) { if (!choose.disabled) chooseReplacement(choose.closest('[data-bb-card]')); return; }
    const btn = e.target.closest('[data-bb-add]');
    if (btn) { addCard(btn.closest('[data-bb-card]')); return; }
    if (e.target.closest('button:disabled')) return;
    const card = e.target.closest('[data-bb-card]');
    if (!card) return;
    e.preventDefault(); // the name links to the spice page; here it opens the popup instead
    openInfo(card);
  });

  list.addEventListener('click', (e) => {
    // Change: replace mode on the spice menu right here (no popup). Tapping it again cancels.
    const ch = e.target.closest('[data-bb-change-slot]');
    if (ch) {
      const i = Number(ch.dataset.bbChangeSlot);
      if (!slots[i]) return;
      replacing = replacing === i ? -1 : i;
      selected = -1;
      render();
      if (replacing >= 0) {
        const r = replaceBar.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.6) replaceBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    const x = e.target.closest('[data-bb-remove]');
    if (!x) return;
    slots[Number(x.dataset.bbRemove)] = null;
    selected = -1;
    render();
  });

  // Start Over empties the box on screen (card choice included); Undo puts it back for a few seconds.
  const undoBar = $('[data-bb-undo]');
  let undoState = null;
  let undoTimer = 0;
  if (undoBar) {
    undoBar.querySelector('[data-bb-undo-text]').textContent = T.cleared;
    undoBar.querySelector('[data-bb-undo-btn]').textContent = T.undo;
  }
  const hideUndo = () => { clearTimeout(undoTimer); undoState = null; if (undoBar) undoBar.hidden = true; };
  $('[data-bb-clear]').addEventListener('click', () => {
    undoState = { size, picks: slots.slice(), card: { ...cardSel[size] } };
    slots = boxes[size] = new Array(size).fill(null);
    cardSel[size] = { on: false, msg: false };
    selected = -1;
    replacing = -1;
    render();
    if (undoBar) {
      undoBar.hidden = false;
      clearTimeout(undoTimer);
      undoTimer = setTimeout(hideUndo, 8000);
    }
  });
  undoBar?.querySelector('[data-bb-undo-btn]').addEventListener('click', () => {
    if (!undoState) return;
    boxes[undoState.size] = undoState.picks;
    cardSel[undoState.size] = undoState.card;
    if (undoState.size === size) slots = boxes[size];
    hideUndo();
    render();
  });
  // Any new pick ends the chance to undo.
  grid.addEventListener('click', (e) => { if (undoState && e.target.closest('[data-bb-add]')) hideUndo(); }, true);

  // Greeting Card (+ Custom Message) for this box.
  cardOn?.addEventListener('change', () => {
    cardSel[size] = { on: cardOn.checked, msg: cardOn.checked && cardSel[size].msg };
    render();
  });
  msgOn?.addEventListener('change', () => {
    // A message needs a card: ticking it adds the Greeting Card too.
    cardSel[size] = { on: msgOn.checked ? true : cardSel[size].on, msg: msgOn.checked };
    render();
  });

  $('[data-bb-search]').addEventListener('input', (e) => {
    const q = e.target.value.trim().toLowerCase();
    cards.forEach((c) => { c.hidden = q && !c.dataset.search.includes(q); });
  });

  // Drag (pointer events: mouse, pen and touch) or tap-to-swap, on box slots and list rows.
  let drag = null;
  const slotAt = (x, y) => {
    const el = document.elementFromPoint(x, y)?.closest('[data-slot]');
    return el && root.contains(el) ? el : null;
  };
  const clearTargets = () => root.querySelectorAll('.is-target').forEach((el) => el.classList.remove('is-target'));
  function onDown(e) {
    if (e.button > 0 || e.target.closest('[data-bb-remove],[data-bb-change-slot]')) return;
    const el = e.target.closest('[data-slot]');
    if (!el) return;
    const r = el.getBoundingClientRect();
    drag = { from: Number(el.dataset.slot), x: e.clientX, y: e.clientY, moved: false, ghost: null, id: e.pointerId, el, offX: e.clientX - r.left, offY: e.clientY - r.top, w: r.width };
  }
  function onMove(e) {
    if (!drag || e.pointerId !== drag.id) return;
    const s = slots[drag.from];
    if (!s) return;
    if (!drag.moved && Math.hypot(e.clientX - drag.x, e.clientY - drag.y) < 6) return;
    e.preventDefault();
    if (!drag.moved) {
      drag.moved = true;
      let g;
      if (drag.el.classList.contains('bb-row')) {
        // Dragging a list row: the whole row floats under the pointer, held where it was grabbed.
        g = drag.el.cloneNode(true);
        g.classList.remove('is-selected', 'is-target');
        g.classList.add('bb-row-ghost');
        g.style.width = `${drag.w}px`;
        list.append(g);
        drag.row = true;
        drag.el.classList.add('is-dragging');
      } else {
        g = document.createElement('div');
        g.className = 'bb-ghost';
        g.append(art(s, ''));
        document.body.append(g);
      }
      drag.ghost = g;
      selected = -1;
      root.querySelectorAll('.is-selected').forEach((el) => el.classList.remove('is-selected'));
    }
    drag.ghost.style.left = `${drag.row ? e.clientX - drag.offX : e.clientX}px`;
    drag.ghost.style.top = `${drag.row ? e.clientY - drag.offY : e.clientY}px`;
    clearTargets();
    const t = slotAt(e.clientX, e.clientY);
    if (t && Number(t.dataset.slot) !== drag.from) {
      root.querySelectorAll(`[data-slot="${t.dataset.slot}"]`).forEach((el) => el.classList.add('is-target'));
    }
  }
  function onUp(e) {
    if (!drag || e.pointerId !== drag.id) return;
    const d = drag;
    drag = null;
    clearTargets();
    if (d.ghost) {
      d.ghost.remove();
      const t = slotAt(e.clientX, e.clientY);
      if (t) swap(d.from, Number(t.dataset.slot));
      render();
      return;
    }
    // Tap: select a jar, then tap another slot to swap (or the same one to deselect).
    if (selected === -1) {
      if (slots[d.from]) selected = d.from;
    } else {
      if (selected !== d.from) swap(selected, d.from);
      selected = -1;
    }
    render();
  }
  [photo, list].forEach((zone) => zone.addEventListener('pointerdown', onDown));
  window.addEventListener('pointermove', onMove, { passive: false });
  window.addEventListener('pointerup', onUp);
  window.addEventListener('pointercancel', () => { if (drag?.ghost) { drag.ghost.remove(); drag.el?.classList.remove('is-dragging'); } drag = null; clearTargets(); });
  // Stop the page scrolling under a finger that is dragging a jar.
  [photo, list].forEach((zone) => zone.addEventListener('touchmove', (e) => { if (drag && slots[drag.from]) e.preventDefault(); }, { passive: false }));

  // ---------- Add to cart ----------
  async function addToCart() {
    if (filled() !== size || busy) return;
    busy = true;
    errEl.hidden = true;
    ctas.forEach((b) => { b.disabled = true; b.textContent = T.adding; });
    const box = cfg.boxes[size];
    const arrangement = slots.map((s, i) => `${i + 1}. ${s.title}`).join(', ');
    const base = window.Shopify?.routes?.root || '/';
    try {
      // Number the group ("Set 1", "Set 2", ...; merchant Oct 26 2026) by how many custom boxes are already in the cart.
      let boxNo = 1;
      try {
        const cart = await (await fetch(`${base}cart.js`, { credentials: 'same-origin' })).json();
        const ids = new Set((cart.items || []).map((it) => it.properties?._bb).filter(Boolean));
        boxNo = ids.size + 1;
      } catch (e) {}
      // Every line of this box shares a hidden _bb id (the cart shows them as one row and removes them
      // together). Visible "Custom Box" properties tell the packer which box and slot each jar goes in.
      const bb = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
      const boxName = editing?.label || T.boxN.replace('__N__', boxNo);
      const noBox = !!editing?.noBox;
      const items = noBox ? [] : [{ id: Number(box.variant), quantity: 1, properties: { [T.propBox]: boxName, [T.arrangement]: arrangement, _bb: bb } }];
      slots.forEach((s, i) => items.push({
        id: Number(s.id),
        quantity: 1,
        properties: { [T.propBox]: `${boxName} · ${T.slotN.replace('__N__', i + 1)}`, _bb: bb, _slot: String(i + 1), ...(editing?.set ? { _set: editing.set } : {}), ...(noBox ? { _bbn: String(size) } : {}) },
      }));
      // Greeting Card (+ Custom Message). The message line is pre-assigned to this box ("For Box", same label the
      // cart's box picker uses), so once the message is written in the cart the card shows inside this box.
      // Editing from the cart: the box's card choice is loaded too (editing.card). Only a changed choice touches the
      // card lines, so a written message stays as it is. A plain card carries "For Box" so it shows inside its box.
      const sel = cardSel[size];
      const forBox = `${boxName} · Custom ${size}-Pack`;
      const want = { on: cardOk && sel.on, msg: cardOk && sel.on && msgOk && sel.msg };
      const had = editing?.card || { on: false, msg: false };
      const cardChanged = want.on !== had.on || want.msg !== had.msg;
      const cardUpdates = {};
      if (editing && cardChanged) {
        if (had.msg) {
          if (editing.card.msgKey) cardUpdates[editing.card.msgKey] = 0;
          if (editing.card.gcKey) cardUpdates[editing.card.gcKey] = Math.max(0, editing.card.gcQty - 1);
        } else if (had.on && editing.card.plainKey) {
          cardUpdates[editing.card.plainKey] = 0;
        }
      }
      if (want.on && (!editing || cardChanged)) {
        if (want.msg) {
          items.push({ id: Number(cfg.card.variant), quantity: 1 });
          items.push({ id: Number(cfg.card.msgVariant), quantity: 1, properties: { _card: `${bb}-1`, 'For Box': forBox } });
        } else {
          items.push({ id: Number(cfg.card.variant), quantity: 1, properties: { 'For Box': forBox } });
        }
      }
      const res = await fetch(`${base}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || root.dataset.error);
      }
      // Editing: the updated box is in (added first so nothing is lost on an error); now remove the old box,
      // and give back any spices taken out of it as plain single jars.
      const wasEditing = !!editing;
      if (editing) {
        const updates = { ...cardUpdates };
        editing.keys.forEach((k) => { updates[k] = 0; });
        await fetch(`${base}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        const back = new Map(editing.oldJars);
        slots.forEach((s) => { const v = Number(s.id); if (back.get(v) > 0) back.set(v, back.get(v) - 1); });
        const returned = [...back].filter(([, q]) => q > 0).map(([id, quantity]) => ({ id, quantity }));
        if (returned.length) {
          await fetch(`${base}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: returned }),
          });
        }
        // Size changed but the card choice didn't: its card (+ written message) moves to the new size's label.
        if (size !== editing.size0 && !cardChanged && editing.cardLines?.length) {
          for (const line of editing.cardLines) {
            await fetch(`${base}cart/change.js`, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: { ...line.properties, 'For Box': forBox } }),
            });
          }
        }
        editing = null;
        $('[data-bb-editing]').hidden = true;
        root.querySelectorAll('[data-bb-size]').forEach((b) => { b.disabled = false; });
        const url = new URL(location.href);
        url.searchParams.delete('edit');
        history.replaceState(null, '', url);
      }
      try {
        await customElements.whenDefined('s-cart');
        await customElements.get('s-cart')?.refreshMountedCarts?.();
      } catch (e) {}
      ctas.forEach((b) => { b.textContent = wasEditing ? T.updated : T.added; });
      const drawer = document.getElementById('cart-drawer');
      if (drawer instanceof HTMLDialogElement) {
        if (!drawer.open) drawer.showModal();
        drawer.dispatchEvent(new CustomEvent('s-cart:opened', { bubbles: true, detail: { dialogId: drawer.id } }));
      } else {
        location.href = `${base}cart`;
      }
      if (wasEditing && prevPicks) {
        // Back to the picks they had in progress before editing.
        boxes[3] = prevPicks[3]; boxes[6] = prevPicks[6]; size = prevPicks.size; slots = boxes[size]; prevPicks = null;
        if (prevCard) { cardSel[3] = prevCard[3]; cardSel[6] = prevCard[6]; prevCard = null; }
        buildPhoto();
      } else {
        slots = boxes[size] = new Array(size).fill(null);
        cardSel[size] = { on: false, msg: false };
      }
      setTimeout(() => { busy = false; render(); }, 1200);
    } catch (err) {
      errEl.textContent = err.message || root.dataset.error;
      errEl.hidden = false;
      busy = false;
      render();
    }
  }
  ctas.forEach((b) => b.addEventListener('click', addToCart));

  // Desktop: the box column follows the scroll; when it's taller than the window it scrolls
  // until its bottom (Add Box to Cart) is in view, then stays put.
  const side = root.querySelector('.bb-side');
  function stick() {
    if (!side) return;
    const gap = 16;
    side.style.top = `${Math.min(gap, window.innerHeight - side.offsetHeight - gap)}px`;
  }
  window.addEventListener('resize', stick);
  photo.addEventListener('load', stick, true);

  // Build a Box from a spice page (?add=<variant id>): that spice starts in slot 1 of an empty box, or the next
  // empty slot when picks are already in progress (never twice, never into a full box). The parameter is then
  // dropped from the address so a refresh doesn't add it again.
  const addId = params.get('add');
  if (addId && !params.get('edit')) {
    const card = cards.find((c) => c.dataset.id === addId && !c.hasAttribute('data-soldout'));
    if (card && !slots.some((s) => s && String(s.id) === addId)) {
      const i = slots.indexOf(null);
      if (i >= 0) slots[i] = spiceFromCard(card);
    }
    params.delete('add');
    try { history.replaceState(history.state, '', `${location.pathname}?${params.toString()}${location.hash}`); } catch (e) {}
  }

  buildPhoto();
  render();

  // Edit in Builder (link on a custom box in the cart): load that box's jars into their slots.
  const editId = params.get('edit');
  if (editId) {
    (async () => {
      try {
        const base = window.Shopify?.routes?.root || '/';
        const cart = await (await fetch(`${base}cart.js`, { credentials: 'same-origin' })).json();
        const lines = (cart.items || []).filter((it) => it.properties?._bb === editId);
        const boxLine = lines.find((it) => it.properties?._slot == null);
        const jarLines = lines.filter((it) => it.properties?._slot != null);
        // A group without a gift box (an edited set that isn't a gift) keeps its size on its jars (_bbn).
        const noBox = !boxLine;
        if (noBox && !jarLines.length) return;
        const n = noBox
          ? (jarLines.some((it) => it.properties?._bbn === '6') || jarLines.length > 3 ? 6 : 3)
          : (boxLine.handle === 'large-gift-box' ? 6 : 3);
        if (!cfg.boxes[n]?.variant) return;
        const byVariant = new Map(cards.map((c) => [c.dataset.id, c]));
        const fresh = new Array(n).fill(null);
        const oldJars = new Map();
        lines.filter((it) => it.properties?._slot != null).forEach((it) => {
          oldJars.set(it.variant_id, (oldJars.get(it.variant_id) || 0) + it.quantity);
          const i = Number(it.properties._slot) - 1;
          const card = byVariant.get(String(it.variant_id));
          if (i >= 0 && i < n && card && !fresh[i]) fresh[i] = spiceFromCard(card);
        });
        prevPicks = { 3: boxes[3].slice(), 6: boxes[6].slice(), size };
        const label = noBox ? String(jarLines[0].properties?.[T.propBox] || '').split(' · ')[0] : (boxLine.properties?.[T.propBox] || '');
        editing = { id: editId, keys: lines.map((it) => it.key), label, oldJars, noBox, set: jarLines.find((it) => it.properties?._set)?.properties._set || '' };
        // The card (+ message) already in this box: a Custom Message line or a plain Greeting Card with "For Box" = this box.
        const forBox = `${label} · Custom ${n}-Pack`;
        const all = cart.items || [];
        const msgLine = all.find((it) => it.handle === 'custom-message' && it.properties?.['For Box'] === forBox);
        const plainLine = all.find((it) => it.handle === 'greeting-card' && it.properties?.['For Box'] === forBox);
        const gcLine = all.find((it) => it.handle === 'greeting-card' && !it.properties?.['For Box']);
        editing.card = msgLine
          ? { on: true, msg: true, msgKey: msgLine.key, gcKey: gcLine?.key || '', gcQty: gcLine?.quantity || 0 }
          : plainLine ? { on: true, msg: false, plainKey: plainLine.key } : { on: false, msg: false };
        editing.cardLines = [msgLine, plainLine].filter(Boolean);
        prevCard = { 3: { ...cardSel[3] }, 6: { ...cardSel[6] } };
        cardSel[n] = { on: editing.card.on, msg: editing.card.msg };
        size = n;
        boxes[n] = fresh;
        slots = boxes[n];
        selected = -1;
        editing.size0 = n;
        const note = $('[data-bb-editing]');
        if (note && editing.label) { note.textContent = T.editing.replace('__B__', editing.label); note.hidden = false; }
        buildPhoto();
        render();
      } catch (e) { /* stays a normal builder */ }
    })();
  }
})();
